<template>
  <div style="position: relative">
    <div class="dialog-box" id="dialogBox">
      <div
        v-click-out-side="closeDialog"
        class="dialog-con"
        :style="{width: width, 'background-image':  'url(' + backgroundImage + ')'}"
        :class="{ 'padding-b-20': !showFoot }">
        <div class="top">
          <div class="line"></div>
          <div class="title" style="color: #FFFFFF">{{ title }}</div>
          <img class="close-img" src="../../assets/img/close.png" @click="closeDialog">
        </div>
        <slot></slot>
        <div class="foot" v-if="showFoot">
          <div class="box2" @click="closeDialog">取消</div>
          <div class="box4" @click="confirmDialog">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    title: { type: String, default: '标题' },
    width: { type: String, default: '500px' },
    backgroundImage: { type: String, default: require('../../assets/dp/classInBg.png') },
    showFoot: { type: Boolean, default: true }
  },
  data () {
    return {

    }
  },
  directives: {
    ClickOutSide: {
      inserted (el, binding) {
        function handleFun (e) { // 判断所点击dom是否为el的节点
          if (el.contains(e.target)) {
            console.log('在节点内')
          } else {
            console.log('在节点外')
            binding.value(e)
          }
        }
        el.function = handleFun
        document.getElementById('dialogBox').addEventListener('click',  el.function)
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close')
    },
    confirmDialog () {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="less">
.dialog-box{
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  top: 0;
  left: 0;
  .padding-b-20{
    padding-bottom: 20px !important;
  }
  .dialog-con{
    padding: 20px 20px 80px 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-height: 100px;
    //background-image: url("../../assets/dp/classInBg.png");
    background-size: 100% 100%;
    .top{
      height: 40px;
      font-size: 24px;
      text-shadow: 3px 3px 5px #32b0f8;
      border-bottom: 1px solid #4A96C5;
      display: flex;
      position: relative;
      .line{
        width: 4px;
        height: 26px;
        background-color: #00B2FF;
        margin-right: 10px;
        margin-top: 4px;
      }
      .close-img{
        position: absolute;
        right: 0;
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
    .foot{
      display: flex;
      position: absolute;
      bottom: 30px;
      justify-content: center;
      width: 100%;
      div{
        height: 50px;
        width: 190px;
        background-size: 100% 100%;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        cursor: pointer;
      }
      .box2{
        background-image: url("../../assets/img/box2.png");
        color: #00FFF6;
      }
      .box4{
        background-image: url("../../assets/img/box4.png");
        color: #00B2FF;
      }
    }
  }
}

/deep/ .el-input.is-disabled .el-input__inner{
  background-color: #005174;
  box-shadow: 0 0 0px 0px inset #0f2d48;
  border: 1px solid #06577c;
}
/deep/ .el-input__inner {
  width: 100%;
  height: 40px;
  font-size: 18px;
  line-height: inherit;
  font-weight: 500;
  background: rgba(0, 45, 65, 0.2);
  border: 1px solid #00B2FF;
  color: #00B2FF;
  box-shadow: 0 0 12px 4px rgba(0, 178, 255, 0.2) inset;

  &::-webkit-input-placeholder {
    color: rgba(0, 178, 255, 0.3);
  }
}
/deep/ .el-form-item__label{
  color: #FFFFFF;
}
</style>
